import React from "react";
import { Name } from "./Name";
import { EventDate } from "./Date";
import { Time } from "./Time";

export function DetailRows() {
  const rows = [
    {
      id: "name",
      component: Name,
    },
    {
      id: "date",
      component: EventDate,
    },
    {
      id: "time",
      component: Time,
    },
  ];

  return (
    <>
      {rows.map((row) => (
        <row.component key={row.id} />
      ))}
    </>
  );
}
